import styled from "styled-components";
export { StyledButton } from "../../shared/styled/TitleBar";

export const OutsourceOrderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    height: 100%;
    button, input { font-family: "Noto Sans", sans-serif; }
`;
